export interface EnvironmentModel {
    name: string;
    production: boolean;
    dev: boolean;
    BASE_URL: string;
    usersGraphQLURL: string;
    listingGraphQLURL: string;
    suppliersGraphQLURL: string;
    distributionManagementGraphQLURL: string;
    maxBulkEditableListings: number;
    featureFlags: FeatureFlags;
    iceDashboardUrl: string;
}

export enum FeatureFlagEnum {
    CONTENT_VISUALS_SPLIT = 'contentVisualsSplit',
    MONITORING_TAB = 'monitoringTab',
    RESTRICTIVE_UI = 'restrictiveUi',
    CHECK_FOR_DUPLICATED_ASSETS = 'checkForDuplicatedAssets',
    REPLACE_ASSET = 'replaceAsset',
    LISTING_CHANNEL_COMPARISON = 'listingChannelComparison',
    LISTING_CHANNEL_COMPARISON_LOGS = 'listingChannelComparisonLogs',
    VISUALS_DASHBOARD = 'visualsDashboard',
    VISUALS_CATEGORY_COVERAGE = 'visualsCategoryCoverage',
    VISUALS_IMAGE_TRACKER = 'visualsImageTracker',
    VISUALS_CUSTOM_CONTENT = 'visualsCustomContent',
    UNIFIED_LISTING = 'unifiedListing',
    AI_SPENDING_LIMITS = 'aiSpendingLimits',
}

export type FeatureFlags = {
    [key in FeatureFlagEnum]: boolean;
};
